export default __webpack_public_path__ + "static/media/bell.bdd7fa71.svg";